import { Image } from "@/components/common/Image"
import { ShortTransaction } from "@usher/pe-client-front-end-lib"
import { getCoinIcon } from "@/pages/Topup/sections/ByCrypto/CurrencyTable"

type ActivityProps = {
  activity: ShortTransaction
}
export const Activity = ({ activity }: ActivityProps) => {
  const { date_created, fiat_amount, fiat_currency, crypto_amount, crypto_currency } = activity
  const date = new Date(date_created)

  return (
    <div className="activities-row d-flex justify-content-between">
      <div className="activities-curency">
        <div className="activities-curency__name d-flex">
          <Image src={"coins/" + getCoinIcon(crypto_currency) + ".svg"} className="activities-curency__ic" />
          <h4 className="activities-curency__title">{crypto_currency}</h4>
        </div>
        <p className="activities-curency__date">{date.toLocaleString()}</p>
      </div>
      <div className="activities-num">
        <p className="activities-num__crypto d-flex">
          {crypto_amount > 0 ? crypto_amount : "_"}
          <span>{crypto_currency}</span>
        </p>
        <p className="activities-num__cur d-flex">
          {Number(fiat_amount).toLocaleString("en-US", {
            style: "currency",
            currency: fiat_currency,
          })}
        </p>
      </div>
    </div>
  )
}
